module.exports = __webpack_public_path__ + "static/media/neonGenesis.a51dd401.jpeg";